(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-best-seller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bfcm-best-seller')) {
    customElements.define('bfcm-best-seller', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.bfcm-best-seller__viewport');
        // Shared cards also emit module scripts; only actual cards belong in pages.
        this.cards ||= Array.from(this.viewport.children).filter((element) =>
          element.matches('.bfcm-best-seller__item')
        );
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.dots = this.querySelector('[data-dots]');
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.page = 0;
        this.querySelectorAll('quick-view').forEach((modal) => this.append(modal));
        this.observer = new ResizeObserver(() => this.carousel?.resize());
        if (typeof Flickity !== 'undefined') this.rebuild();
        else document.addEventListener('DOMContentLoaded', () => this.rebuild(), { ...options, once: true });
        this.previous.addEventListener('click', () => this.goTo(this.page - 1), options);
        this.next.addEventListener('click', () => this.goTo(this.page + 1), options);
        this.dots.addEventListener('click', (event) => {
          const button = event.target.closest('[data-page]');
          if (button) this.goTo(Number(button.dataset.page));
        }, options);
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport) return;
          if (!this.carousel || !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.goTo(0);
          else this.goTo(this.pages.length - 1);
        }, options);
        this.mobile.addEventListener('change', () => this.rebuild(), options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.carousel?.destroy();
        this.carousel = null;
      }

      rebuild() {
        if (typeof Flickity === 'undefined') return;
        const firstCard = (this.page || 0) * (this.perPage || 5);
        this.carousel?.destroy();
        this.perPage = this.mobile.matches ? 2 : 5;
        const fragment = document.createDocumentFragment();
        this.pages = [];
        for (let index = 0; index < this.cards.length; index += this.perPage) {
          const page = document.createElement('div');
          page.className = 'bfcm-best-seller__page';
          page.setAttribute('data-card-grid', '');
          page.append(...this.cards.slice(index, index + this.perPage));
          fragment.append(page);
          this.pages.push(page);
        }
        this.viewport.replaceChildren(fragment);
        this.setAttribute('data-ready', '');
        this.dots.replaceChildren(...this.pages.map((page, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.dataset.page = index;
          dot.setAttribute('aria-label', this.dataset.pageLabel.replace('[page]', index + 1));
          dot.setAttribute('aria-controls', this.viewport.id);
          return dot;
        }));
        this.page = Math.min(Math.floor(firstCard / this.perPage), this.pages.length - 1);
        this.carousel = new Flickity(this.viewport, {
          cellSelector: '.bfcm-best-seller__page',
          cellAlign: 'left',
          contain: true,
          groupCells: false,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          draggable: '>1',
          accessibility: true,
          rightToLeft: getComputedStyle(this).direction === 'rtl',
          initialIndex: this.page
        });
        this.carousel.on('select', () => {
          this.page = this.carousel.selectedIndex;
          this.updateControls();
        });
        this.observer.disconnect();
        this.observer.observe(this.viewport);
        this.pages.forEach((page) => this.observer.observe(page));
        this.updateControls();
      }

      goTo(page, animate = true) {
        if (!this.carousel) return;
        this.carousel.select(page, true, !animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      }

      updateControls() {
        const single = this.pages.length <= 1;
        this.previous.hidden = single;
        this.next.hidden = single;
        this.dots.hidden = single;
        this.previous.disabled = single;
        this.next.disabled = single;
        Array.from(this.dots.children).forEach((dot, index) => {
          dot.setAttribute('aria-current', index === this.page ? 'true' : 'false');
        });
      }


    });
  }

  } catch(e) { console.error(e); }
})();
})();
